// NOTE: 'vertical-ref' is the cycle 2 mode for the Securitization vertical reference.
// The design contract §6 uses 'reference' for a no-auth single-surface mode — that mode
// is preserved here. 'vertical-ref' differs: it requires Keycloak auth and exposes the
// full nav (Dashboard | Marketplace | Administration | OrgSwitcher | avatar).
// Contract mode-name rename ADR deferred to cycle 4+ per brief §2.5.
export type InstanceMode = 'tier-0' | 'reference' | 'tier-1-hub' | 'vertical-ref';

export interface TileConfig {
  id: string;
  title: string;
  description: string;
  mark: string;
  action: 'order' | 'launch' | 'manage';
  href?: string;
  vertical: string;
  status: 'public' | 'private' | 'coming-soon';
  tags: string[];
  instances?: {
    name: string;
    slug: string;
    type: string;
    tier: string;
  }[];
}

export interface BrokerConfig {
  instance: {
    mode: InstanceMode;
    name: string;
    slug: string;
  };
  auth: {
    enabled: boolean;
    keycloak?: {
      url: string;
      realm: string;
      clientId: string;
    };
  };
  catalog: {
    tiles: TileConfig[];
  };
  brandTokens?: Partial<{
    brandAccent: string;
    brandSurfaceInverted: string;
    brandWordmarkColor: string;
  }>;
}

export const ALLOWED_BRAND_TOKENS: (keyof NonNullable<BrokerConfig['brandTokens']>)[] = [
  'brandAccent',
  'brandSurfaceInverted',
  'brandWordmarkColor',
];

export const VALID_MODES: InstanceMode[] = ['tier-0', 'reference', 'tier-1-hub', 'vertical-ref'];
